export { PresenceNameplate } from './components/PresenceNameplate.tsx';
export { usePresence } from './hooks/usePresence.ts';
export { presenceState } from './presence-state-instance.ts';
export { type PresenceLayerGroupSnapshot } from './presence-state.ts';
export { startPresenceComponentPings } from './start-presence-component-pings.ts';
export { messages as presenceMessages } from './messages.ts';
export { createParticipantFromIdentity, type Participant } from './types.ts';
export { createPresenceLayerRenderer } from './presence-layer/create-presence-layer-renderer.ts';
export {
  type PresenceViewAdapter,
  type FormatNameplateOverflow
} from './presence-layer/types.ts';
